(ns manage.ad-variant.archive-confirmation-modals
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-mutation]]
            [common.resource.query.decision-tree :as dt-queries]
            [common.resource.query.social-settings :refer [use-auto-publish]]
            [manage.adset-decision-tree-page.view.context :as dt-context]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [uix.core :as uix :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-open-archivation-confirm-modal []
  (let [{{published-id :id} :published
         {draft-id :id} :draft} (uix/use-context dt-context/decision-trees-context)]
    (fn [props]
      (rf/dispatch [:modal/open {:id :ad-variant/archive-confirmation
                                 :props (assoc props
                                               :published-id published-id
                                               :draft-id draft-id)}]))))

(defui open-editor-button [{:keys [published-id draft-id]}]
  (let [url-context (use-subscribe [:url-context])
        navigate-to-editor (fn []
                             (rfe/navigate :adset/ad-variants {:path-params url-context
                                                               :query-params {:view-mode "editor"}
                                                               :fragment "strategy"}))

        {create-draft :mutate}
        (use-mutation (dt-queries/create-draft-decision-tree-mutation
                       (assoc url-context
                              :decision-tree-id published-id
                              :on-success navigate-to-editor)))]
    ($ Button {:variant "contained"
               :on-click (fn []
                           (rf/dispatch [:modal/close])
                           (if draft-id
                             (navigate-to-editor)
                             (create-draft nil)))}
       "Open Decision Tree")))

(defmodal archive-ad-variant-confirmation :ad-variant/archive-confirmation
  [{:keys [on-confirm bulk published-id draft-id]}]
  (let [auto-publish? (use-auto-publish)
        on-archive (fn []
                     (rf/dispatch [:modal/close])
                     (on-confirm (when-not auto-publish?
                                   #(rf/dispatch [:modal/open
                                                  {:id :ad-variant/post-archive-decision-tree
                                                   :props {:published-id published-id
                                                           :draft-id draft-id}}]))))]
    ($ modal-v2
       {:title (if bulk "Archive ad variants?" "Archive ad variant?")
        :footer ($ :<>
                   ($ Button {:onClick #(rf/dispatch [:modal/close])} "Cancel")
                   ($ Button {:variant "contained" :color "error" :onClick on-archive} "Archive"))}
       ($ Box {:sx #js {:width "400px"}}
          (if bulk
            (if auto-publish?
              "Some of the selected ad variants are assigned to a decision tree and will stop serving once archived."
              "Some of the selected ad variants are assigned to a decision tree and will stop serving next time you publish the decision tree. Confirm to proceed.")
            (if auto-publish?
              "This ad variant is assigned to a decision tree and will stop serving once archived. Confirm to proceed."
              "This ad variant is assigned to a decision tree and will stop serving next time you publish the decision tree. Confirm to proceed."))))))

(defmodal post-archive-decision-tree-modal :ad-variant/post-archive-decision-tree
  [{:keys [published-id draft-id]}]
  ($ modal-v2
     {:title "Republish to stop serving"
      :footer ($ :<>
                 ($ Button {:onClick #(rf/dispatch [:modal/close])} "Dismiss")
                 ($ open-editor-button {:published-id published-id :draft-id draft-id}))}
     ($ Box {:sx #js {:width "400px"}}
        "The archived ad variant(s) will continue serving until the decision tree is republished.")))
